module.exports = __webpack_public_path__ + "img/27.9e7514dc.png";